export default function SelectionPill({
  children,
  onClick,
  disabled,
  selected = false,
  size = "normal",
  ariaLabel
}: {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  selected?: boolean;
  size?: "normal" | "small" | "compact";
  ariaLabel?: string;
}) {
  const sizeClasses =
    size === "compact"
      ? "min-h-9 px-3.5 py-1.5 text-sm min-w-[0]"
      : size === "small"
        ? "px-4 py-2 text-lg min-w-[60px]"
        : "px-6 py-3 text-xl min-w-[100px]";

  return (
    <button
      type="button"
      onClick={(e) => {
        (e.currentTarget as HTMLButtonElement).blur();
        onClick?.();
      }}
      disabled={disabled}
      aria-label={ariaLabel}
      className={`
        ${sizeClasses}
        font-semibold rounded-xl
        transition-transform duration-150
        ${!disabled && "active:scale-95"}
        ${
          disabled
            ? "bg-gray-100 text-gray-400 border border-gray-200 cursor-not-allowed opacity-60"
            : selected
              ? "bg-info text-white border-2 border-info shadow-md cursor-pointer hover:bg-info/90"
              : `
              bg-white text-gray-700 border-2 border-gray-200 shadow-sm cursor-pointer
              hover:border-info hover:text-info hover:shadow-md
              active:border-info active:bg-info/5 active:text-info
            `
        }
      `}
    >
      {children}
    </button>
  );
}
